import { useContext, useState } from "react";
import {
  Accordion as UiAccordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../Components/ui/accordion";
import { LanguageContext } from "../context/language/LanguageContext";
import { getLanguageDirection } from "../Utilities/languageDirection";
import '../styles/summary.css';

const toInlineStyle = (sx) => {
  if (!sx || typeof sx !== "object" || Array.isArray(sx)) {
    return {};
  }

  return Object.entries(sx).reduce((acc, [key, value]) => {
    if (!key.startsWith("&")) {
      acc[key] = value;
    }
    return acc;
  }, {});
};

export default function CustomAccordion(props) {
    const languageContext = useContext(LanguageContext);
    const direction = getLanguageDirection(languageContext?.language?.id);
    const isControlled = typeof props.expandedPanel === "boolean";
    const [internalExpanded, setInternalExpanded] = useState(false);
    const isExpanded = isControlled ? props.expandedPanel : internalExpanded;

    const accordionStyle = toInlineStyle(props.accordionSx);
    const summaryStyle = toInlineStyle(props.summarySx);
    const detailsStyle = toInlineStyle(props.detailsSx);

    const handleValueChange = (nextValue) => {
      const nextExpanded = nextValue === "panel-1";

      if (!isControlled) {
        setInternalExpanded(nextExpanded);
      }

      if (typeof props.onChange === "function") {
        props.onChange(undefined, nextExpanded);
      }
    };

    return (
        <div className={"accordion"}>
            <UiAccordion
                type="single"
                collapsible
                className={props.iconColor}
                value={isExpanded ? "panel-1" : ""}
                onValueChange={handleValueChange}
                style={accordionStyle}
            >
                <AccordionItem value="panel-1" className="!border-b-0">
                  <AccordionTrigger
                      dir={direction}
                      className={`accordion-trigger ${props.className || ""}`}
                      style={summaryStyle}
                      icon={props.icon}
                      iconClassName={props.iconColor}
                      iconExpanded={isExpanded}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                  >
                      <div
                        className={`accordion-trigger-content ${isExpanded ? "is-expanded" : ""}`}
                        style={{ margin: 0, flex: 1, minWidth: 0 }}
                      >
                        {props.accordionSummary}
                      </div>
                  </AccordionTrigger>

                  <AccordionContent
                    className="accordion-details"
                    style={detailsStyle}
                  >
                      <div ref={props.contentRef}>
                          {props.accordionDetails}
                      </div>
                  </AccordionContent>
                </AccordionItem>
            </UiAccordion>
        </div>
    );
}
